import React, { useContext } from 'react';

import { UserContext } from './services/firebase/UserProvider';
import { auth } from './services/firebase/firebase';
import { useRoutes } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';
import { logLogout } from './services/utils/logging';
import routes from './routes';

function App() {
    const user = useContext(UserContext);

    const handleOnIdle = async (event) => {
        console.log('user is idle', event)
        console.log('last active', getLastActiveTime())

        if (auth.currentUser) {
            console.log('logging out user')

            // Log the action
            try {
                await logLogout(user.sessionId, 'timeout');
            } catch (error) {
                console.error('Error logging logout:', error);
            }

            // Then sign out
            await auth.signOut();
        }
    }

    const { getRemainingTime, getLastActiveTime } = useIdleTimer({
        timeout: 1000 * 60 * 60,
        onIdle: handleOnIdle,
        debounce: 500
    })

    return useRoutes(routes(user))
}

export default App;
